import http from '@root/utils/axios/admin';

let state = {
    DiscussionsList: [],
    ReportDiscussionsList: [],
    DiscussionCommentsList: [],
    ReportDiscussionCommentsList: [],
    Discussion: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchDiscussionsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/discussions', { params: filter }).then((response) => {
                commit('setDiscussionsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchReportDiscussionsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/reports/discussions', { params: filter }).then((response) => {
                commit('setReportDiscussionsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteDiscussion({ commit }, id) {
        return http.delete('user/discussions/' + id);
    },

    fetchDiscussion({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/discussions/' + id).then((response) => {
                commit('setDiscussion', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateDiscussion({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/discussions', data).then((response) => {
                commit('setDiscussion', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setDiscussionError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateDiscussion({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/discussions/' + data.id, data).then((response) => {
                commit('setDiscussion', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setDiscussionError', error.response.data);
                }
                reject(error.response);
            })
        });
    },

    toggleDiscussion({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/toggle-discussion', data).then((response) => {
                commit('setDiscussion', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setDiscussionError', error.response.data);
                }
                reject(error.response);
            })
        });
    },
    toggleCommentDiscussion({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/toggle-comment-discussion', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        });
    },


    fetchDiscussionCommentsList({ commit }, filter) {
        return new Promise((resolve, reject) => {
            http.get('user/discussion/' + filter.id + '/comments').then((response) => {
                commit('setDiscussionCommentsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },
    fetchReportDiscussionCommentsList({ commit }, filter) {
        return new Promise((resolve, reject) => {
            http.get('user/reports/comments', { params: filter }).then((response) => {
                commit('setReportDiscussionCommentsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteDiscussionComment({ commit }, comment_id) {
        return http.delete('user/discussion/comments/' + comment_id);
    },


}


let mutations = {
    setDiscussionsList(state, data) {
        state.DiscussionsList = data;
    },
    setReportDiscussionsList(state, data) {
        state.ReportDiscussionsList = data;
    },
    setDiscussionCommentsList(state, data) {
        state.DiscussionCommentsList = data;
    },
    setReportDiscussionCommentsList(state, data) {
        state.ReportDiscussionCommentsList = data;
    },
    setDiscussion(state, data) {
        state.Discussion.data = data;
    },
    setDiscussionError(state, error) {

        state.Discussion.error = error.errors;
    },
    cleanDiscussionError(state, error) {
        state.Discussion.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}